// Body Map V2 geometry — mirrors backend/routes/body_map_geometry.py
// ONE coordinate system on the REAL CQC Expert template: a mark is stored as a
// percentage of the full template image, so the same value reproduces exactly
// in the exported PDF regardless of display/PDF size.

export const FRONT = 'front';
export const BACK = 'back';
export const LEFT_SIDE = 'left_side';
export const RIGHT_SIDE = 'right_side';
export const BODY_VIEWS = [FRONT, BACK, LEFT_SIDE, RIGHT_SIDE];

export const VIEW_LABELS = {
  [FRONT]: 'Front',
  [BACK]: 'Back',
  [LEFT_SIDE]: 'Left side',
  [RIGHT_SIDE]: 'Right side',
};

// Vertical band (y0%, y1%) each view's figure occupies in the full composite.
export const VIEW_BANDS = {
  [FRONT]: [0, 26],
  [RIGHT_SIDE]: [26, 49],
  [LEFT_SIDE]: [49, 66],
  [BACK]: [66, 100],
};

// (x%, y%) of the full CQC Expert composite for each named region — used only
// as a suggested start marker and as the legacy region-only fallback.
export const REGION_TEMPLATE_COORDS = {
  'Head – top':            [77.0, 7.0],
  'Forehead':              [76.0, 8.0],
  'Left eye / cheek':      [74.0, 9.5],
  'Right eye / cheek':     [74.0, 13.5],
  'Nose':                  [75.0, 11.5],
  'Mouth / lips':          [75.0, 12.5],
  'Left ear':              [80.0, 9.0],
  'Right ear':             [80.0, 14.0],
  'Chin / jaw':            [75.5, 14.5],
  'Neck – front':          [68.0, 16.5],
  'Neck – back':           [68.0, 16.5],
  'Left shoulder':         [62.0, 13.0],
  'Right shoulder':        [62.0, 19.0],
  'Chest – left':          [54.0, 14.0],
  'Chest – right':         [54.0, 18.0],
  'Abdomen – left':        [45.0, 16.0],
  'Abdomen – right':       [45.0, 18.0],
  'Groin / perineal area': [35.0, 18.0],
  'Left upper arm':        [65.0, 8.0],
  'Left elbow':            [50.0, 5.0],
  'Left forearm':          [38.0, 4.0],
  'Left wrist':            [28.0, 3.5],
  'Left hand / fingers':   [18.0, 3.0],
  'Right upper arm':       [65.0, 22.0],
  'Right elbow':           [50.0, 24.0],
  'Right forearm':         [38.0, 24.5],
  'Right wrist':           [28.0, 24.8],
  'Right hand / fingers':  [18.0, 25.0],
  'Left hip':              [34.0, 10.5],
  'Left thigh':            [27.0, 10.0],
  'Left knee':             [20.0, 10.0],
  'Left lower leg / shin': [12.0, 10.0],
  'Left ankle':            [6.0, 10.5],
  'Left foot / toes':      [2.0, 11.0],
  'Right hip':             [34.0, 16.5],
  'Right thigh':           [27.0, 17.0],
  'Right knee':            [20.0, 17.0],
  'Right lower leg / shin':[12.0, 17.0],
  'Right ankle':           [6.0, 16.5],
  'Right foot / toes':     [2.0, 16.0],
  'Upper back – left':     [65.0, 70.0],
  'Upper back – right':    [65.0, 81.0],
  'Lower back – left':     [52.0, 73.0],
  'Lower back – right':    [52.0, 80.0],
  'Sacrum / coccyx':       [42.0, 78.0],
  'Buttocks – left':       [40.0, 71.0],
  'Buttocks – right':      [40.0, 82.0],
};

export const BODY_REGIONS = Object.keys(REGION_TEMPLATE_COORDS);

const BACK_REGIONS = new Set([
  'Neck – back', 'Upper back – left', 'Upper back – right',
  'Lower back – left', 'Lower back – right', 'Buttocks – left',
  'Buttocks – right', 'Sacrum / coccyx',
]);

export function normalizeView(view) {
  if (!view) return null;
  let v = String(view).trim().toLowerCase().replace(/[-\s]/g, '_');
  const aliases = { left: LEFT_SIDE, right: RIGHT_SIDE, leftside: LEFT_SIDE, rightside: RIGHT_SIDE };
  v = aliases[v] || v;
  return BODY_VIEWS.includes(v) ? v : null;
}

export function clampPct(value) {
  if (value === null || value === undefined || value === '') return null;
  const f = Number(value);
  if (Number.isNaN(f)) return null;
  return Math.max(0, Math.min(100, f));
}

export function regionDefaultView(region) {
  return BACK_REGIONS.has(region) ? BACK : FRONT;
}

export function regionSuggestedCoords(region) {
  const c = REGION_TEMPLATE_COORDS[region];
  return c ? { x: c[0], y: c[1] } : { x: 50, y: 50 };
}
